<div #chart echarts [options]="chartOptions" [merge]="updateOptions" [initOpts]="initOptions" (chartInit)="onChartInit($event)" class="visual"></div>
